import React from 'react'
import { StructuredData } from '../..'
import { FACEBOOK_URL_START, YELP_URL_START, MILAN_PHONE, FIREBASE_STORAGE_PATH } from '../../../utils'

const TXRoom = `${FIREBASE_STORAGE_PATH}general%2Fseo%2FTXRoom.webp?alt=media&token=f59ef1d6-65ce-429e-8f41-a688657ef2d9`
const MILAN_LOGO = `${FIREBASE_STORAGE_PATH}general%2Fseo%2FMilan-Logo-Blue.webp?alt=media&token=eacafc73-400d-4131-bde8-3b469aca0229`

export function StoreStructuredData({ currentMetro, currentStore }) {
	return (
	<StructuredData>
		{
			{
				"@context": "https://www.schema.org",
				"@type": "HealthAndBeautyBusiness",
				"name": `Milan laser Hair Removal | ${currentStore.marketingCity} | ${currentStore.stateAbbrev}`,
				"url": `${currentMetro.origin}/locations/${currentMetro.metroPath}/${currentMetro.stores.length > 1 ? currentStore.pathname : null}`,
				"sameAs": [`${FACEBOOK_URL_START}${currentStore.platforms.facebook}`,`${YELP_URL_START}${currentStore.platforms.yelp}`],
				"logo": `${MILAN_LOGO}`,
				"image": `${TXRoom}`,
				"priceRange": "$$",
				"telephone": `${currentStore.phone === '' ? MILAN_PHONE : currentStore.phone}`,
				"description": "Laser Hair Removal | Milan Laser is one of the nation’s leading laser hair removal companies. We are committed to providing our clients with world-class customer service and permanent results. Our physicians and highly-trained medical staff utilize ongoing medical research to ensure that all treatments are performed safely and are tailored to give every client the best results possible. Our goal is to provide 100% customer satisfaction to every client and we will do everything we can to ensure our clients are happy with their experience as well as their results.",
				"address": {
					"@type": "PostalAddress",
					"streetAddress": `${currentStore.address}`,
					"addressLocality": `${currentStore.addressCity === '' ? currentStore.marketingCity : currentStore.addressCity}`,
					"addressRegion": `${currentStore.stateAbbrev}`,
					"postalCode": `${currentStore.zipCode}`,
					"addressCountry": "United States"
				},
				"geo": {
					"@type": "GeoCoordinates",
					"latitude": `${currentStore.geo.lat}`,
					"longitude": `${currentStore.geo.long}`
				},
				"hasMap": `${currentStore.maps.google}`,
				"openingHours": "Mo, Tu, We, Th 10:00-19:00 Fr 09:00-17:00 Sa 9:00-15:00",
				"contactPoint": {
					"@type": "ContactPoint",
					"telephone": `${currentStore.phone === '' ? MILAN_PHONE : currentStore.phone}`,
					"contactType": "customer service"
				}
			}
		}
	</StructuredData>
	)
}